var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreenInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_15083)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4695 4.48672C8.68394 4.7115 8.67556 5.06756 8.45078 5.282L5.69922 7.907C5.48175 8.11446 5.13961 8.11432 4.92232 7.90667L3.54888 6.59417C3.32428 6.37954 3.3162 6.02347 3.53083 5.79888C3.74546 5.57428 4.10153 5.5662 4.32612 5.78083L5.31127 6.72227L7.67422 4.468C7.899 4.25356 8.25506 4.26195 8.4695 4.48672Z",
    fill: "#52C41A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.0625C3.82538 2.0625 2.0625 3.82538 2.0625 6C2.0625 8.17462 3.82538 9.9375 6 9.9375C8.17462 9.9375 9.9375 8.17462 9.9375 6C9.9375 3.82538 8.17462 2.0625 6 2.0625ZM0.9375 6C0.9375 3.20406 3.20406 0.9375 6 0.9375C8.79594 0.9375 11.0625 3.20406 11.0625 6C11.0625 8.79594 8.79594 11.0625 6 11.0625C3.20406 11.0625 0.9375 8.79594 0.9375 6Z",
    fill: "#52C41A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_15083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenInvoice);
export default __webpack_public_path__ + "static/media/check-green-invoice.f0e34cf6.svg";
export { ForwardRef as ReactComponent };